import { WitboostSearchApi } from '../WitboostSearchApi';
import { sleep } from '@agilelab/plugin-wb-platform-common';
import { generateFakeResults } from './fakeResults';
import {
  AvailableSearchFilterValues,
  WitboostMarketplaceSearchResultSet,
} from '@agilelab/plugin-wb-search-common';
import { SearchQuery } from '@backstage/plugin-search-common';
import { ApiRef, createApiRef } from '@backstage/core-plugin-api';

export class MockWitboostSearchApi implements WitboostSearchApi {
  async getAvailableFilterValues(): Promise<AvailableSearchFilterValues> {
    return {};
  }

  async query(
    _query: SearchQuery,
  ): Promise<WitboostMarketplaceSearchResultSet> {
    await sleep(200);
    const results = generateFakeResults(15);
    return { results, numberOfResults: results.length };
  }
}

export const witboostMockSearchApiRef: ApiRef<WitboostSearchApi> =
  createApiRef<WitboostSearchApi>({
    id: 'witboost.search.mock',
  });
